import { jsx as _jsx } from "react/jsx-runtime";
import { TableCell } from '@mui/material';
import styled from 'styled-components';
import { ColumnWithTooltip } from './ColumnWithTooltip';
const StyledStickyHeaderCell = styled(TableCell) `
  && {
    box-sizing: border-box;
    position: sticky;
    background-color: #ffffff;
    vertical-align: bottom;
    z-index: 3;
    ${({ cw }) => cw && `width: ${cw}; min-width: ${cw}; max-width: ${cw}; `};
    ${({ ch }) => `height: ${ch};`};
    ${({ tp }) => `top: ${tp};`};
    ${({ hta }) => hta && `text-align: ${hta};`};
    ${({ rb }) => rb === 'true' && 'border-right: 1px solid #e8e3f5;'};
  }
`;
const StyledTopStickyHeaderCell = styled(StyledStickyHeaderCell) `
  && {
    top: 0;
    text-align: center;
    &&:not(:last-of-type) {
      border-right: 1px solid #e8e3f5;
    }
  }
  &&:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    border-top: 1px solid #e8e3f5;
  }
`;
export const StickyHeaderCell = ({ title, customHeight = '40px', customWidth, headerTextAlign = 'left', rightBorder = false, topPosition = '40px', isTopHeader = false, colSpan }) => {
    return isTopHeader ? (_jsx(StyledTopStickyHeaderCell, Object.assign({ ch: customHeight, colSpan: colSpan, cw: customWidth }, { children: _jsx(ColumnWithTooltip, Object.assign({ title: title }, { children: title })) }))) : (_jsx(StyledStickyHeaderCell, Object.assign({ ch: customHeight, cw: customWidth, hta: headerTextAlign, rb: rightBorder.toString(), tp: topPosition, colSpan: colSpan }, { children: _jsx(ColumnWithTooltip, Object.assign({ title: title }, { children: title })) })));
};
